import React, {FC, useEffect, useState} from 'react'
import {Button} from 'react-bootstrap'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {HasPermissionInGroup, HasPermissionInRole} from 'app/shared/Common/Util'
import {Group, Role} from 'app/shared/Common/Enums'
import {useAuth} from 'app/modules/auth'

const Error404: FC = () => {
  const {currentUser} = useAuth()
  const [MainPage, setMainPage] = useState<'Dashboard' | 'Home Page'>('Dashboard')

  useEffect(() => {
    if (
      HasPermissionInRole(currentUser, [Role.EXT_Report_Full, Role.EXT_Report_Read]) &&
      HasPermissionInGroup(currentUser, [Group.Member_User_Administrator, Group.Member_Normal_User, Group.Member_Stakeholder])
    ) {
      setMainPage('Dashboard')
    } else {
      setMainPage('Home Page')
    }
  }, [])

  return (
    <div className='d-flex flex-column flex-root'>
      <div className='d-flex flex-column flex-center flex-column-fluid p-10 text-center'>
        <img src={toAbsoluteUrl('/media/logos/logo_reversed.svg')} alt='' className='mw-100 mb-20 h-100px' />

        <h1 className='fw-bolder fs-2qx mb-10'>Page Not Found</h1>
        <div className='fw-bold fs-2 text-muted'>
          We're sorry, the page you requested could not be found.
          <br />
          Please go back to {MainPage}.
        </div>

        <Button variant='primary' className='mt-5' href='/'>
          Go {MainPage}
        </Button>
      </div>
    </div>
  )
}

export {Error404}
